import gql from 'graphql-tag';

export default gql(`
	query email_external( $guid: String! ) {
		email_external( guid: $guid ) {
			guid
			subject
			text
			sub_text
			kind
			message_kind
			actions
		}
	}
`);

